import React, { useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { Box, Button, Typography, Grid } from "@mui/material"
import LoginError from "../../../components/LoginError"
import { F_START_LOGIN } from "../../../constants/routes"
import useMutation from "../../../hooks/useMutation"
import ValidateEmailCode from "./ValidateEmailCode"

const ValidateEmail = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const emailParam = searchParams.get("email")
  const codeParam = searchParams.get("code")

  const [errorMsg, setErrorMsg] = useState("")
  const [showLoginError, setShowLoginError] = useState("none")

  const [emailVerified, setEmailVerified] = useState(false)

  const { mutate: verifyMutation, loading: verifyLoading } = useMutation("/auth/verify")

  useEffect(() => {
    const verifyFunc = async () => {
      if (emailParam && codeParam) {
        console.log("render", emailParam)
        console.log("render2", codeParam)
        try {
          const res = await verifyMutation({ email: emailParam, emailCode: codeParam })
          if (res.error) {
            setShowLoginError("inherit")
            setErrorMsg(res.message)
          } else {
            setEmailVerified(true)
            localStorage.removeItem("validateEmail")
          }
        } catch (e) {
          console.log(e.message)
          setErrorMsg(e.message)
        }
      }
    }

    if (!emailVerified && !verifyLoading && !errorMsg) {
      verifyFunc()
    }
  }, [codeParam, emailParam, emailVerified, verifyMutation, verifyLoading, errorMsg])

  if (!emailParam || !codeParam) {
    return <ValidateEmailCode />
  }

  return (
    <Grid container>
      <Grid item xs={1} md={4}>
        <Box></Box>
      </Grid>
      <Grid item xs={10} md={4}>
        <Box
          sx={{
            mx: "auto",
            mt: 3,
            borderWidth: "2px",
            borderStyle: "solid",
            borderColor: "start.main",
            borderRadius: "12px",
            p: 3,
            width: "100%",
          }}>
          <Typography variant="h6" sx={{ color: "black" }}>
            E-Mail-Bestätigung
          </Typography>
          <Typography variant="body2" sx={{ color: "black" }}>
            {verifyLoading
              ? "E-Mail wird bestätigt..."
              : emailVerified
              ? "Deine Email wurde bestätigt. Du kannst dich nun einloggen."
              : "Ein Fehler ist aufgetreten"}
          </Typography>

          <Button
            onClick={() => navigate(F_START_LOGIN)}
            fullWidth
            disabled={verifyLoading}
            sx={{ mt: 3, color: "white", backgroundColor: "start.main", height: "3.5rem" }}>
            Zur App
          </Button>

          <LoginError msg={errorMsg} visible={showLoginError} />
        </Box>
      </Grid>
      <Grid item xs={1} md={4}>
        <Box></Box>
      </Grid>
    </Grid>
  )
}

export default ValidateEmail
